// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { ExternalSearchResult } from '@models/ExternalSearchResult';
import { SearchResult } from '@models/imported/SagaBase/PersistentObject';
import { CNote } from '@models/imported/SagaSchema/CNote';
import { ListCardStatus } from '@models/imported/SagaStateLib/ListCardStatus';
import { Color } from '../../color';
import { CallCard_abstract } from './../abstract/SagaSchema/CallCard_abstract';
import { CCaller } from './CCaller';
import { CEvent } from './CEvent';
import { CLocation } from './CLocation';
import { CStampCard } from './CStampCard';

export class CallCard extends CallCard_abstract {
  static globalIcon: string = 'md-insert_drive_file';

  name: string = CallCard.$t;
  rLong: string[] = [];
  title: string = CallCard.$t;

  status: ListCardStatus = null;
  callers: CCaller[] = [];
  event: CEvent = null;
  preattribution: CStampCard = null;

  externalSearchs: { Far?: ExternalSearchResult } = {
    Far: new ExternalSearchResult()
  };

  get icon() {
    return CallCard.globalIcon;
  }

  get colorArray(): number[] {
    return this.status && this.status.color && this.status.color.toArray();
  }

  get color(): Color {
    return this.status && this.status.color;
  }

  get colorRgb(): string {
    return this.status && this.status.color && this.status.color.tinycolor.toRgbString();
  }

  get location(): CLocation {
    return this.component<CLocation>(CLocation).length ? this.component<CLocation>(CLocation)[0] : null;
  }

  get note(): CNote {
    return this.component<CNote>(CNote).length ? this.component<CNote>(CNote)[0] : null;
  }

  constructor() {
    super();
  }

  rShort(): string {
    return this.name;
  }

  search(term: string): SearchResult {
    let path = null;
    const searchTerm = term.toLocaleLowerCase();
    if (this.event.EventText.toLowerCase().includes(searchTerm)) {
      path = 'event';
    } else if (this.location.text.toLowerCase().includes(searchTerm)) {
      path = 'location';
    }
    return new SearchResult(term, this, path);
  }
}
